var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1 3.0885C3.666 3.0885 2.5 4.32829 2.5 5.85305C2.5 13.7086 8.511 20.1012 15.9 20.1012C17.333 20.1012 18.5 18.8614 18.5 17.3366C18.5 17.2186 18.493 17.1027 18.479 16.9878L13.859 15.8607C13.767 16.0479 13.666 16.251 13.574 16.4402C13.118 17.3653 12.788 18.0373 11.946 17.6769C8.64 16.4434 5.941 13.5725 4.766 10.0148C4.409 9.18009 5.089 8.80156 5.951 8.32308C6.126 8.22526 6.315 8.11999 6.488 8.02429L5.428 3.11082C5.317 3.09594 5.209 3.0885 5.1 3.0885ZM15.9 22.2277C7.408 22.2277 0.5 14.8825 0.5 5.85305C0.5 3.15548 2.563 0.961914 5.1 0.961914C5.36 0.961914 5.617 0.985306 5.866 1.03103C6.109 1.0725 6.353 1.13842 6.591 1.22561C6.916 1.34576 7.161 1.63604 7.238 1.99331L8.607 8.33477C8.683 8.68353 8.588 9.0493 8.354 9.30875C8.218 9.45973 8.215 9.46292 6.975 10.153C7.979 12.4646 9.724 14.3137 11.854 15.3451C12.504 14.0255 12.508 14.0213 12.65 13.8766C12.894 13.6278 13.24 13.5311 13.566 13.6076L19.531 15.0633C19.866 15.1452 20.139 15.4046 20.251 15.7502C20.333 16.0011 20.395 16.2605 20.436 16.5274C20.478 16.7901 20.5 17.0623 20.5 17.3366C20.5 20.0342 18.436 22.2277 15.9 22.2277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fc7a1854bc9316e53d67fa8206e54726.svg";
export { ForwardRef as ReactComponent };